'use client';

import Box from '@mui/material/Box';
import { scrollToId } from '@/libs/scroll';

// Flecha al contenido, centrada al pie de un hero oscuro (artículo del blog, ranking).
export default function ScrollCue({ target, label }) {
  return (
    <Box
      component="button"
      type="button"
      onClick={() => scrollToId(target)}
      aria-label={label}
      sx={{
        cursor: 'pointer',
        p: 0,
        display: { xs: 'none', md: 'flex' },
        position: 'absolute',
        bottom: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 2,
        width: 42,
        height: 42,
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '50%',
        border: '1px solid',
        borderColor: 'grey.700',
        color: 'text.muted',
        bgcolor: 'rgba(10,15,14,0.55)',
        backdropFilter: 'blur(2px)',
        transition: 'color 0.15s, border-color 0.15s, transform 0.15s',
        '&:hover': {
          color: 'primary.glow',
          borderColor: 'primary.glow',
          transform: 'translateX(-50%) translateY(2px)',
        },
      }}
    >
      <Box component="svg" width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden="true">
        <path d="M4 6l4 4 4-4" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      </Box>
    </Box>
  );
}
